import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f9476d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "text-left border-b border-gray-200 dark:border-gray-700" };
const _hoisted_2 = { class: "px-2 pb-4" };
const _hoisted_3 = { class: "pb-4" };
const _hoisted_4 = {
    key: 0,
    class: "text-right pb-4 w-24"
};
const _hoisted_5 = { class: "px-2 py-3" };
const _hoisted_6 = { class: "flex space-x-4" };
const _hoisted_7 = ["v-model", "onChange"];
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "flex justify-end pr-1 space-x-1 text-badge" };
const _hoisted_10 = {
    key: 0,
    class: "px-1 border rounded-sm red-badge"
};
const _hoisted_11 = {
    key: 1,
    class: "px-1 border rounded-sm orange-badge"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.choose_team_table'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed } from 'vue';
import AvatarList from '@/components/users/AvatarList.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ChooseTeamTable',
    props: {
        teams: null,
        selectedTeam: null
    },
    emits: ["update:selectedTeam"],
    setup(__props, { emit }) {
        const props = __props;
        const isStatusColumnVisible = computed(() => props.teams.some((t) => t.upcomingRetroDate || t.hasInProgressRetro));
        function handleTeamChoice(team) {
            emit('update:selectedTeam', team);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("table", null, [
                _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_1, [
                        _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('team_name')), 1),
                        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('teammates')), 1),
                        (_unref(isStatusColumnVisible))
                            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_ctx.$t('status')), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.teams, (t) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            key: t.id,
                            class: "border-b border-gray-200 dark:border-gray-700"
                        }, [
                            _createElementVNode("td", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("input", {
                                        id: "selectedTeam",
                                        name: "selectedTeam",
                                        required: true,
                                        type: "radio",
                                        "v-model": __props.selectedTeam?.id === t.id,
                                        onChange: ($event) => (handleTeamChoice(t))
                                    }, null, 40, _hoisted_7),
                                    _createElementVNode("div", null, _toDisplayString(t.name), 1)
                                ])
                            ]),
                            _createElementVNode("td", null, [
                                _createVNode(AvatarList, {
                                    users: t.members,
                                    invitations: t.invitations,
                                    size: "sm"
                                }, null, 8, ["users", "invitations"])
                            ]),
                            (_unref(isStatusColumnVisible))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        (t.hasInProgressRetro)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('in_progress_retro')), 1))
                                            : (t.upcomingRetroDate)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('upcoming_retro')), 1))
                                                : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
